<template>
  <div class="FaqBox">
    <div class="row">
        <div class="col text-right" dir="rtl">
            <div class="accordion" id="faq-p">
                <div class="card" :key="(faq,index)" v-for="(faq,index) in faqs">
                    <div class="card-header">
                        <button class="btn-faq" aria-label="دیدن پاسخ" data-bs-toggle="collapse" :data-bs-target="'#faq-accordion-' + faq.id">{{faq.name}}</button>
                    </div>
                    <div :id="'faq-accordion-' + faq.id" class="collapse" :class="index == 0 ? 'show' : ''" data-bs-parent="#faq-p">
                        <div class="card-body" v-html="faq.text"></div>
                    </div>
                </div>
              </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqBox',
  data () {
    return {
      faqs: []
    }
  },
  props: {
    objs: Array
  },
  mounted () {
    this.faqs = this.objs
  },
  watch: {
    objs (to, from) {
      this.faqs = this.objs
    }
  }
}
</script>

<style scoped>
.btn-faq{
  text-align: right;
  background: transparent;
  border: none;
  padding: 7px;
}
.card , .card-header{
  border:none !important;
  margin-bottom: 2px;
}
</style>
